<template>
    <div ref="breadcrumb" class="pt-breadcrumb" aria-label="Breadcrumb" role="navigation">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent, provide, ref, onMounted } from 'vue';
import type { IBreadcrumbProps } from './breadcrumb';

export default defineComponent({
    name: 'PtBreadcrumb',
    props: {
        separator: {
            type: String,
            default: '/',
        },
        separatorIcon: {
            type: String,
            default: '',
        },
        separatorIconStyle: {
            type: Object,
            default: {
                width: '12px',
                height: '12px',
            },
        },
    },
    setup(props) {
        const breadcrumb = ref(null);

        provide<IBreadcrumbProps>('breadcrumb', props);

        onMounted(() => {
            const items = breadcrumb.value.querySelectorAll('.pt-breadcrumb__item');
            if (items.length) {
                items[items.length - 1].setAttribute('aria-current', 'page');
            }
        });

        return {
            breadcrumb,
        };
    },
});
</script>

<style lang="scss" src="../style/breadcrumb.scss"></style>
